import { combineReducers } from 'redux'

import { accountApi, unauthenticatedAccountApi } from '../api/account'
import { aiAnalystApi } from '../api/ai-analyst'
import { combinedApi } from '../api/combined'
import { connectServerApi } from '../api/connect'
import { coreApi, unauthenticatedCoreApi } from '../api/core'
import { feedApi } from '../api/feed'
import { keycloakApi } from '../api/keycloak'
import { liveEventPredictionsApi } from '../api/live-event-predictions'
import { reportsApi } from '../api/reports'
import { topGrossingServerApi } from '../api/top-grossing'
import { uaInsightsApi } from '../api/ua-insights'
import GRPopoverReducers from '../components/GRPopover/reducers/GRPopoverReducer'
import liveEventModalReducer from '../features/live-events/slices/liveEventModalSlice'
import liveEventsTrackerCalendarsReducer from '../features/live-events/slices/liveEventsCalendarsSlice'
import sidebarReducer from '../features/sidebar/slices/sidebarSlice'
import snackBarMessageReducer from '../features/snackbar/reducers/snackBarMessageReducer'
import { mainStoreIdReducer } from '../features/store'
import { aiPromptsApi } from '../internal/api/ai-prompts'
import { internalCoreApi } from '../internal/api/internal'
import { internalCombinedApi } from '../internal/api/internal-combined'
import { internalLiveEventPredictionsApi } from '../internal/api/live-event-predictions'
import { internalMarketsApi } from '../internal/api/markets'
import { internalOpenAIChatApi } from '../internal/api/openai-chat'
import currentPageReducer from './currentPageReducer'

const allReducers = combineReducers({
  currentPage: currentPageReducer,
  mainStoreId: mainStoreIdReducer,
  snackBarMessage: snackBarMessageReducer,
  sidebar: sidebarReducer,
  grPopover: GRPopoverReducers,
  liveEventModal: liveEventModalReducer,
  liveEventsTrackerCalendars: liveEventsTrackerCalendarsReducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [unauthenticatedAccountApi.reducerPath]: unauthenticatedAccountApi.reducer,
  [combinedApi.reducerPath]: combinedApi.reducer,
  [coreApi.reducerPath]: coreApi.reducer,
  [unauthenticatedCoreApi.reducerPath]: unauthenticatedCoreApi.reducer,
  [connectServerApi.reducerPath]: connectServerApi.reducer,
  [topGrossingServerApi.reducerPath]: topGrossingServerApi.reducer,
  [feedApi.reducerPath]: feedApi.reducer,
  [aiAnalystApi.reducerPath]: aiAnalystApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [keycloakApi.reducerPath]: keycloakApi.reducer,
  [internalCoreApi.reducerPath]: internalCoreApi.reducer,
  [internalOpenAIChatApi.reducerPath]: internalOpenAIChatApi.reducer,
  [internalCombinedApi.reducerPath]: internalCombinedApi.reducer,
  [liveEventPredictionsApi.reducerPath]: liveEventPredictionsApi.reducer,
  [internalLiveEventPredictionsApi.reducerPath]: internalLiveEventPredictionsApi.reducer,
  [internalMarketsApi.reducerPath]: internalMarketsApi.reducer,
  [aiPromptsApi.reducerPath]: aiPromptsApi.reducer,
  [uaInsightsApi.reducerPath]: uaInsightsApi.reducer,
})

export default allReducers
